import { combineReducers } from "redux";

import postCreationModal, {
  PostCreationModalActions,
} from "@app/component/PostCreationModal/store";

import activityAnnotation, { ActivityAnnotationActions } from "./activity/ActivityAnnotation/store";
import addToRouteModal, { AddToRouteModalActions } from "./AddToRouteModal/store";
import entityAssociations, { EntityAssociationsActions } from "./associations/store";
import createEditActivityModal, {
  CreateEditActivityModalActions,
} from "./createEditEntity/Activity/store";
import addNoteModal, { AddNoteModalActions } from "./createEditEntity/AddNoteModal/store";
import createCompanyModal, {
  CreateCompanyModalActions,
} from "./createEditEntity/CreateCompanyModal/store";
import createDealModal, { CreateDealModalActions } from "./createEditEntity/CreateDealModal/store";
import createPersonModal, {
  CreatePersonModalActions,
} from "./createEditEntity/CreatePersonModal/store";
import editStageModal, { EditStageModalActions } from "./createEditEntity/EditStageModal/store";
import dataView, { DataViewActions } from "./DataView/store";
import { EntityAnnotationActions } from "./EntityAnnotation/store/index";
import entityEmails, { EntityEmailsActions } from "./EntityEmails/store";
import entityHistory, { EntityHistoryActions } from "./EntityHistoryModal/store";
import entityMentions, { EntityMentionsActions } from "./EntityMentions/store";
import filePreview, { FilePreviewActions } from "./FilePreview/store";
import { UserLocationRequestActions } from "./Layout/components/UserLocationRequest/actions";
import userLocationRequest from "./Layout/components/UserLocationRequest/store";
import leadFinder, { LeadFinderActions } from "./leadFinder/store";
import multiPin from "./map/domains/entities/drawer/store";
import { MultiPinRecordsActions } from "./map/domains/entities/drawer/store/actions";
import navigationBar, { NavigationBarActions } from "./NavigationBar/store";
import activityRecord, { ActivityRecordActions } from "./preview/ActivityRecordPane/store";
import companyRecord, { CompanyRecordActions } from "./preview/CompanyRecordPane/store";
import recordBrief, { RecordBriefActions } from "./preview/components/RecordFieldAgent/store";
import recordCharts, { RecordChartsActions } from "./preview/components/RecordFieldInsights/store";
import dealRecord, { DealRecordActions } from "./preview/DealRecordPane/store";
import personRecord, { PersonRecordActions } from "./preview/PersonRecordPane/store";
import dealListModal, { DealListModalActions } from "./PreviewDealsListModal/store";
import tripModal, { TripModalActions } from "./tripModal/store";
import userPreviewCard, { UserPreviewCardActions } from "./UserPreviewCard/store";
import selectBar, { SelectBarActions } from "./view/SelectBar/store";

const componentReducer = combineReducers({
  activityAnnotation,
  activityRecord,
  addNoteModal,
  addToRouteModal,
  companyRecord,
  createCompanyModal,
  createDealModal,
  createEditActivityModal,
  createPersonModal,
  dataView,
  dealListModal,
  dealRecord,
  editStageModal,
  entityAssociations,
  entityEmails,
  entityHistory,
  entityMentions,
  filePreview,
  leadFinder,
  multiPin,
  navigationBar,
  personRecord,
  postCreationModal,
  recordBrief,
  recordCharts,
  selectBar,
  tripModal,
  userLocationRequest,
  userPreviewCard,
});

export type ComponentActions =
  | ActivityAnnotationActions
  | ActivityRecordActions
  | AddNoteModalActions
  | AddToRouteModalActions
  | CompanyRecordActions
  | CreateCompanyModalActions
  | CreateDealModalActions
  | CreateEditActivityModalActions
  | CreatePersonModalActions
  | DataViewActions
  | DealListModalActions
  | DealRecordActions
  | EditStageModalActions
  | EntityAnnotationActions
  | EntityAssociationsActions
  | EntityEmailsActions
  | EntityHistoryActions
  | EntityMentionsActions
  | FilePreviewActions
  | LeadFinderActions
  | MultiPinRecordsActions
  | NavigationBarActions
  | PersonRecordActions
  | PostCreationModalActions
  | RecordBriefActions
  | RecordChartsActions
  | SelectBarActions
  | TripModalActions
  | UserLocationRequestActions
  | UserPreviewCardActions;

export default componentReducer;
